import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { EventManager } from 'src/app/core/services';
declare let $;
@Injectable({ providedIn: 'root' })
export class ExecuteBeforeRequestInterceptor implements HttpInterceptor {
  private readonly SERVER_API_URL: any;
  extra: any;
  quanlity: any = 0;
  id: any = Date.now();
  singleAPIs: any = {};
  modalRef: any;
  isLoad: boolean = false;
  listNoLoadingAPI: any = [];
  callAPI: any = {};
  constructor(
    private eventManager: EventManager,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpResponse<any>> {
    let splits = request.url.split('/');
    let api = '';
    splits.forEach((item, index) => {
        if (index > 2) {
          api += '/' + item;
        }
    })
    api = api.replace('/web', '');
    this.beforeRequest(api, request.method);
    return next.handle(request)
    .pipe(
      tap(
        (res: HttpResponse<any>) => {
          if (res.status) {
            this.hideSpinner(api);
          }
          const version = localStorage.getItem("version");
          this.extra = res.body ? res.body.extra : null;
          if (this.extra) {
            if (version && this.extra.clientVersion > version) {
                localStorage.setItem("version", this.extra.clientVersion);
                location.reload();
            } else  if (!version) {
                localStorage.setItem("version", this.extra.clientVersion);
            }
         }
        },
        (err: any) => {
          this.hideSpinner(api);
          return err;
        }
      ),
    )
  }
  checkExistNoLoadingAPI(api, method?) {
    this.listNoLoadingAPI = (this.listNoLoadingAPI.length  ?  this.listNoLoadingAPI :  JSON.parse(sessionStorage.getItem('noLoadingAPIs'))) || [];
    return this.listNoLoadingAPI.some((item: any) => { 
      return api.includes(item.url) && (!item.method || (item.method && item.method === method));
    })
  }
  private beforeRequest(api?, method?): void {
    this.quanlity++;
    if (this.checkExistNoLoadingAPI(api, method)) {
      return;
    }
    // show spinner
    if (this.isLoad) {
      return;
    }
    this.isLoad = true;
    this.callAPI[api] = true;
    setTimeout(() => {
      if (!this.isLoad || !this.callAPI[api]) {
        return;
      }
      console.log('loading api:', api);
      this.eventManager.broadcast({
        name: 'show-spinner',
        content: {}
      });
    }, 2000)
  }
  hideSpinner(api) {
    this.callAPI[api] = false;
    this.quanlity--;
    // close spinner
    if (this.quanlity <= 0) {
      this.isLoad = false;
      setTimeout(() => {
        this.eventManager.broadcast({
          name: 'close-spinner',
          content: {}
        })
      }, 500);
    }
  }
}
